import { useRef } from 'react';

import { Box, Portal, useOutsideClick } from '@chakra-ui/react';
import { staticRoutes } from 'Deer/constants/routes';
import { setGlobalSearchVisible, useSelectIsGlobalSearchVisible } from 'Deer/slice/DeerNav.slice';
import { useDispatch } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';

import { isMobileView } from 'constants/isMobileView';

import { DeerEmployeeSearch } from './DeerEmployeeSearch';
import { getEmployeesSearchOptions } from './services';

const GlobalSearch = () => {
  const dispatch = useDispatch();
  const isGlobalSearchVisible = useSelectIsGlobalSearchVisible();
  const ref = useRef<HTMLDivElement>(null);
  const history = useHistory();

  useOutsideClick({
    ref,
    handler: (e) => {
      const targetElement = document.getElementById('primary-nav-search-btn');
      if (targetElement?.contains(e.target as Node)) {
        return;
      }
      dispatch(
        setGlobalSearchVisible({
          isGlobalSearchVisible: false,
        })
      );
    },
  });

  const onChangeHandler = ({ id }: { id: string }) => {
    const route = generatePath(staticRoutes.profile, {
      employeeId: id,
    });
    history.push(route);
    dispatch(
      setGlobalSearchVisible({
        isGlobalSearchVisible: false,
      })
    );
  };

  if (!isGlobalSearchVisible) {
    return null;
  }

  return (
    <Portal>
      <Box
        style={{
          position: 'fixed',
          top: '30%',
          left: '50%',
          zIndex: 10000,
          transform: 'translate(-50%, -50%)',
          width: isMobileView() ? '200px' : '550px',
          padding: '16px',
          borderRadius: '8px',
          background: '#FFFFFF',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
        }}
        ref={ref}
      >
        <DeerEmployeeSearch
          placeholder="Search Mesh"
          loadOptions={getEmployeesSearchOptions}
          onChange={onChangeHandler}
        />
      </Box>
    </Portal>
  );
};

export { GlobalSearch };
